/**
 * @prettier
 */

import React, { useContext, useEffect, useState } from 'react'

import AuthContext from '../../context/auth/AuthContext'
import ItemContext from '../../context/item/ItemContext'

import { useFormHandler } from '../../utils/Custom'

import CategoryListPage from '../ui/CategoryListPage'
import { CardContainer, ListContainer } from '../layout/Containers'
import { PlusIcon } from '../../img/images'
import Drawer from '../input/Drawer'
import CategoryListCollectionRefactor from '../ui/CategoryListCollectionRefactor'
import { withComponentLabel } from '../../utils/debug'

const ItemsPage = () => {
  const itemContext = useContext(ItemContext)
  const authContext = useContext(AuthContext)

  const { getItems, addItem, clearCurrentItem } = itemContext
  const { loadUser } = authContext

  const [loading, setLoading] = useState(true)
  const [theseItems, setTheseItems] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)

  useEffect(() => {
    const loadItemsList = async () => {
      await loadUser()
      const items = await getItems()
      setTheseItems(items)
      clearCurrentItem() // NOTE - if this isn't here, clicking on a store in the list will show the details of the previous store
      setShowDrawer(false)
      setLoading(false)
    }

    loadItemsList()
    // eslint-disable-next-line
  }, [])

  const [changeVal, submitVal, state] = useFormHandler(addItem, { name: '' })

  const itemAdd = async () => {
    setLoading(true)
    const newItem = await submitVal(state)
    setTheseItems((prevState) => [...prevState, newItem])
    changeVal({ name: '' })
    setLoading(false)
  }

  const onChange = (e) => {
    e.preventDefault()
    changeVal({ [e.target.name]: e.target.value })
  }

  const handleModalClick = () => {
    setShowDrawer(!showDrawer)
  }

  const addIcon = (
    <PlusIcon
      color="fill-gray-700"
      height="9"
      width="9"
    />
  )

  return (
    <ListContainer>
      <CardContainer>
        {!loading && (
          <>
            <CategoryListPage
              model={theseItems}
              headerString="Items"
            >
              <Drawer
                addIcon={addIcon}
                handleButtonClick={handleModalClick}
                display={showDrawer}
                action={itemAdd}
                onChange={onChange}
                placeholder="New item name"
              />
              <CategoryListCollectionRefactor
                type="items"
                collection={theseItems}
              />
            </CategoryListPage>
          </>
        )}
      </CardContainer>
    </ListContainer>
  )
}

export default withComponentLabel(ItemsPage, 'ItemsPage')
